import { render, staticRenderFns } from "./BaseTLGrid.vue?vue&type=template&id=15eb3950&"
import script from "./BaseTLGrid.vue?vue&type=script&lang=ts&"
export * from "./BaseTLGrid.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports